import { AutoComplete, Col, Form } from 'antd';
import { Rule } from 'antd/es/form';
import { NamePath } from 'antd/es/form/interface';
import { DefaultOptionType } from 'rc-cascader';
import { FormInstance } from 'rc-field-form';
import { useEffect, useState } from 'react';

import dayjs from 'dayjs';
import { useGetFinalRegHajjiInfoQuery } from '../api/endpoints/packageRateEndpoints';
import { pilgrimInfoType } from '../types/InvoiceHajjTypes';

type Props = {
  size: number;
  name?: NamePath;
  label: string;
  validateStatus: boolean | undefined;
  help: string;
  rules?: Rule[] | undefined;
  required?: boolean;
  fullNamePath: NamePath;
  form: FormInstance<any>;
  disabled?: boolean;
  clientId?: number;
};

const FinalRegTrackingNo = ({
  size,
  name,
  label,
  validateStatus,
  help,
  rules,
  required,
  form,
  fullNamePath,
  disabled,
  clientId,
}: Props) => {
  // Get All Approved Hajj Pre
  const { data } = useGetFinalRegHajjiInfoQuery(Number(clientId), {
    skip: !clientId,
  });
  const approvedHajjPre = data?.data;

  const [options, setOptions] = useState<DefaultOptionType[]>();

  const handleOptionSelect = (data: string) => {
    const selectedItem = approvedHajjPre?.find(
      (item) => item.hajiinfo_final_reg_tracking_id === data
    );
    const namePath = [...(fullNamePath as [])];
    if (selectedItem) {
      const prevValue: pilgrimInfoType = form.getFieldValue([namePath[0], namePath[1]]);

      // @SET VALUES USING TRACKING NUMBER
      form.setFields([
        {
          name: [namePath[0], namePath[1], 'hajiinfo_dob'],
          value: selectedItem?.hajiinfo_dob
            ? dayjs(selectedItem?.hajiinfo_dob)
            : prevValue.hajiinfo_dob,
        },
        {
          name: [namePath[0], namePath[1], 'hajiinfo_mobile'],
          value: selectedItem?.hajiinfo_mobile
            ? selectedItem?.hajiinfo_mobile?.split('-')[1]
            : prevValue.hajiinfo_mobile?.split('-')[1],
        },
        {
          name: [namePath[0], namePath[1], 'hajiinfo_name'],
          value: selectedItem?.hajiinfo_name
            ? selectedItem?.hajiinfo_name
            : prevValue.hajiinfo_name,
        },
        {
          name: [namePath[0], namePath[1], 'hajiinfo_tracking_number'],
          value: selectedItem?.hajiinfo_final_reg_tracking_id
            ? selectedItem?.hajiinfo_final_reg_tracking_id
            : prevValue.hajiinfo_final_reg_tracking_id,
        },
        {
          name: [namePath[0], namePath[1], 'haji_info_haji_id'],
          value: selectedItem?.haji_info_haji_id
            ? selectedItem?.haji_info_haji_id
            : prevValue.haji_info_haji_id,
        },
        {
          name: [namePath[0], namePath[1], 'hajiinfo_gender'],
          value: selectedItem?.hajiinfo_gender
            ? selectedItem?.hajiinfo_gender
            : prevValue.hajiinfo_gender,
        },
        {
          name: [namePath[0], namePath[1], 'hajiinfo_nid'],
          value: selectedItem?.hajiinfo_nid ? selectedItem?.hajiinfo_nid : prevValue.hajiinfo_nid,
        },
        {
          name: [namePath[0], namePath[1], 'hajiinfo_serial'],
          value: selectedItem?.hajiinfo_serial
            ? selectedItem?.hajiinfo_serial
            : prevValue.hajiinfo_serial,
        },
      ]);
    }
  };

  useEffect(() => {
    setOptions(
      approvedHajjPre?.map((item) => ({
        label: `${item.hajiinfo_name} ${item.hajiinfo_final_reg_tracking_id}`,
        value: item.hajiinfo_final_reg_tracking_id,
      }))
    );
  }, [approvedHajjPre]);

  return (
    <Col xs={24} sm={12} md={8} lg={{ span: size || 8, offset: 0 }}>
      <Form.Item
        rules={[...(rules || [])]}
        name={name}
        label={label}
        validateStatus={validateStatus ? 'error' : 'validating'}
        help={validateStatus ? help : null}
        required={required}
      >
        <AutoComplete
          onSearch={(data) => {
            const filter = approvedHajjPre
              ?.filter((item) => item.hajiinfo_final_reg_tracking_id.includes(data))
              .map((item) => ({
                label: `${item.hajiinfo_name} ${item.hajiinfo_final_reg_tracking_id}`,
                value: item.hajiinfo_final_reg_tracking_id,
              }));

            setOptions(filter);
          }}
          onSelect={handleOptionSelect}
          placeholder={label}
          options={options}
          disabled={disabled}
        />
      </Form.Item>
    </Col>
  );
};

export default FinalRegTrackingNo;
